module.exports = __webpack_public_path__ + "img/graph-es.3cd602cd.png";